import React from "react";
import LegalPersonForm from "./LegalPersonForm";
var LegalPersonCreate = function () { return React.createElement(LegalPersonForm, null); };
export default LegalPersonCreate;
